import {ReactNode} from 'react';
import StatusModal, {StatusModalStates} from 'components/StatusModal';
import {GuestsProcessingModal} from 'components/GuestRegisteringModal';

type GuestCreationModalProps = {
  isOpen: boolean;
  state: StatusModalStates;
  title: string;
  successSubtitle: ReactNode;
  errorMessage: string;
  errorMessages?: string[];
  onClose: () => void;
};

export const GuestCreationModal = ({
  isOpen,
  state,
  title,
  successSubtitle,
  errorMessage,
  errorMessages,
  onClose,
}: GuestCreationModalProps) => {
  return (
    <StatusModal open={isOpen} state={state} maxWidth="350px">
      <GuestsProcessingModal
        title={title}
        state={state}
        onClose={onClose}
        errorMessage={errorMessage}
        errorMessages={errorMessages}
        successSubtitle={successSubtitle}
      />
    </StatusModal>
  );
};
